import { createContext, useContext, useEffect } from 'react';
import type { Stripe } from '@stripe/stripe-js';

export const StripeLoaderContext = createContext<(() => Promise<Stripe | null>) | null>(null);

// Renvoie l'instance Stripe en la chargeant au besoin : à attendre juste avant un paiement.
export function useStripeLoader(): () => Promise<Stripe | null> {
  const ensureStripe = useContext(StripeLoaderContext);
  if (!ensureStripe) throw new Error('useStripeLoader doit être utilisé dans StripeProvider');
  return ensureStripe;
}

// Pour les formulaires qui affichent un champ carte : Stripe.js est chargé dès leur affichage.
export function useStripeOnMount(enabled = true) {
  const ensureStripe = useStripeLoader();
  useEffect(() => {
    if (enabled) void ensureStripe();
  }, [enabled, ensureStripe]);
}
